export const errorMessage = function(err: any): string {
    return err + ". Please refresh and try again."
}